import { useCallback } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { createInvoiceWithAuthorizedInvoiceId, getLineItemsWithAuthorizedInvoiceId } from ".";

export default function useGetAuthorizedInvoiceById(
  authorizedInvoiceId,
  selectedPaymentMethods = []
) {
  const { sessionJWT } = useSessionJWT();
  const {
    sessionCtx: { isEscrow },
  } = useSessionCtx();

  // Since the API has two different endpoints for us to go fetch line items, depending
  // on whether or not a payment method has been selected, we need to handle some logic
  // here around which endoint to point to and with what data
  const fetchInvoice = useCallback(() => {
    try {
      if (selectedPaymentMethods?.length > 0) {
        return createInvoiceWithAuthorizedInvoiceId(
          sessionJWT,
          authorizedInvoiceId,
          selectedPaymentMethods,
          isEscrow
        );
      } else {
        return getLineItemsWithAuthorizedInvoiceId(sessionJWT, authorizedInvoiceId);
      }
    } catch (error) {
      return new Promise.reject(error);
    }
  }, [selectedPaymentMethods, authorizedInvoiceId, sessionJWT, isEscrow]);

  return useQuery({
    queryKey: ["invoices", "details", { authorizedInvoiceId, selectedPaymentMethods }],
    queryFn: fetchInvoice,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
}
